<template>
    <div class="compare-analysis flow-container">
        <ParamsHeader></ParamsHeader>
        <Card style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>流量概况</span>
                </div>
            </template>
            <div class="total-line">
                <div class="total-block">
                    <div class="title-line">
                        <span>总流量(人次)</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ "1,262,866" }}</span>
                    </div>
                </div>
                <div class="split-line"></div>
                <div class="total-block">
                    <div class="title-line">
                        <span>集客力(人/㎡)</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ "5.96" }}</span>
                    </div>
                </div>
                <div class="split-line"></div>
                <div class="total-block">
                    <div class="title-line">
                        <span>游逛深度</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ "19.21" }}</span>
                    </div>
                </div>
                <div class="total-block">
                    <div class="title-line">
                        <span>同比</span>
                    </div>
                    <div class="number-line">
                        <span style="color: red" class="sk-number-total">{{ "-19.1%" }}</span>
                    </div>
                </div>
                <div class="total-block">
                    <div class="title-line">
                        <span>环比</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ "39.07%" }}</span>
                    </div>
                </div>
                <div class="total-block">
                    <div class="title-line">
                        <span>平均流量</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ "419,931" }}</span>
                    </div>
                </div>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>业态集客力对比</span>
                </div>
            </template>
            <div style="margin-top: 15px">
                <ChartMap class="chart-normal" ref="first-chart"></ChartMap>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>节假日效益对比</span>
                </div>
            </template>
            <div style="margin-top: 15px">
                <ChartMap class="chart-normal" ref="second-chart"></ChartMap>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>五个重要节假日对标</span>
                </div>
            </template>
            <div style="padding: 0px 20px 20px; display: flex; margin-top: 20px">
                <div style="flex: 1">
                    <ChartMap class="chart-normal" ref="third-chart"></ChartMap>
                </div>
                <div style="flex: 1">
                    <ChartMap class="chart-normal" ref="fourth-chart"></ChartMap>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader";

export default {
    name: "compareAnalysis",
    components: {
        ParamsHeader,
    },
    data() {
        return {};
    },
    methods: {
        buildChart() {
            let firstChart = this.firstChart();
            this.$refs["first-chart"].setData(firstChart);
            let secondChart = this.secondChart();
            this.$refs["second-chart"].setData(secondChart);
            let thirdChart = this.thirdChart();
            this.$refs["third-chart"].setData(thirdChart);
            let fourthChart = this.fourthChart();
            this.$refs["fourth-chart"].setData(fourthChart);
        },
        firstChart() {
            let option = {
                color: ["#5B9BD5", "#ED7D31", "#A5A5A5", "#A5A5A5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "业态集客力对标",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: ["华中区", "华北区", "华南区"],
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["零售", "餐饮", "其他", "娱乐"],
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "华中区",
                        data: [120, 132, 101, 134],
                        type: "bar",
                    },
                    {
                        name: "华北区",
                        data: [220, 182, 191, 234],
                        type: "bar",
                    },
                    {
                        name: "华南区",
                        data: [150, 232, 201, 154],
                        type: "bar",
                    },
                ],
            };
            return option;
        },
        secondChart() {
            let option = {
                color: ["#5B9BD5", "#ED7D31", "#A5A5A5", "#A5A5A5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "节假日效应对比",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: ["华中区", "华北区", "华南区"],
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["周末", "元旦", "春节", "清明", "劳动节", "端午", "中秋", "国庆", "双十一", "圣诞"],
                    axisLine: {
                        show: false,
                        onZero: true,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "华中区",
                        data: [4.9, -7.0, -23.2, 25.6, 76.7, 135.6, 162.2, -32.6, 20.0, 6.4],
                        type: "bar",
                    },
                    {
                        name: "华北区",
                        data: [5.9, -9.0, -26.4, 28.7, 70.7, 175.6, 182.2, -48.7, 18.8, 6.0],
                        type: "bar",
                    },
                    {
                        name: "华南区",
                        data: [3.9, -8.0, -25.4, 27.7, 73.7, 174.6, 179.2, -45.7, 22.8, 8.0],
                        type: "bar",
                    },
                ],
            };
            return option;
        },
        thirdChart() {
            let option = {
                color: ["#4472C4", "#FFC000", "#A5A5A5", "#ED7D31", "#CCCCCC"],
                title: {
                    text: "节假日效应对标",
                    left: "center",
                },
                legend: {
                    right: 30,
                    bottom: 10,
                    orient: "vertical",
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    top: 80,
                    left: "3%",
                    right: "4%",
                    containLabel: true,
                },
                radar: {
                    // shape: 'circle',
                    center: ["50%", "60%"],
                    indicator: [
                        { name: "元旦", max: 6500 },
                        { name: "圣诞", max: 16000 },
                        { name: "双十一", max: 30000 },
                        { name: "国庆", max: 38000 },
                        { name: "劳动节", max: 52000 },
                    ],
                },
                series: [
                    {
                        type: "radar",
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000],
                                name: "华北区",
                            },
                            {
                                value: [5000, 14000, 28000, 26000, 42000],
                                name: "华南区",
                            },
                            {
                                value: [2200, 4000, 16000, 38000, 40000],
                                name: "华东区",
                            },
                            {
                                value: [6000, 13000, 25000, 30000, 42000],
                                name: "华中区",
                            },
                        ],
                    },
                ],
            };
            return option;
        },
        fourthChart() {
            let option = {
                color: ["#4472C4", "#FFC000", "#A5A5A5", "#ED7D31", "#CCCCCC"],
                title: {
                    text: "节假日客流对标",
                    left: "center",
                },
                legend: {
                    right: 30,
                    bottom: 10,
                    orient: "vertical",
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: 0,
                    containLabel: true,
                },
                radar: {
                    // shape: 'circle',
                    center: ["50%", "60%"],
                    indicator: [
                        { name: "元旦", max: 6500 },
                        { name: "圣诞", max: 16000 },
                        { name: "双十一", max: 30000 },
                        { name: "国庆", max: 38000 },
                        { name: "劳动节", max: 52000 },
                    ],
                },
                series: [
                    {
                        type: "radar",
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000],
                                name: "华北区",
                            },
                            {
                                value: [5000, 14000, 28000, 26000, 42000],
                                name: "华南区",
                            },
                            {
                                value: [2200, 4000, 16000, 38000, 40000],
                                name: "华东区",
                            },
                            {
                                value: [6000, 13000, 25000, 30000, 42000],
                                name: "华中区",
                            },
                        ],
                    },
                ],
            };
            return option;
        },
    },
    mounted() {
        this.buildChart();
    },
};
</script>

<style scoped>
.total-block {
    height: 70px;
    position: relative;
}
.total-line .split-line {
    height: 70px;
}
.sk-number-total {
    color: #666682;
}
</style>
